import { getAPI, postAPI, putAPI } from "../../api";
import { REACT_APP_CANDIDATE, REACT_APP_CANDIDATE_FREELANCER, REACT_APP_CUSTOMER, REACT_APP_JOB, REACT_APP_PROFILE, REACT_APP_RECRUITER } from "../../utils/common";


export async function getDetails(Id: string | null){
    const Details = getAPI( REACT_APP_CANDIDATE + '/candidates/' + `${Id}`)
    return Details
}

export async function submitDetails(data: any){
    const Details = postAPI( REACT_APP_CANDIDATE_FREELANCER+ `/candidate-profile`, data)
    return Details
}

export async function submitResume(data: any, id: string | null){
    const Resume = postAPI(  REACT_APP_PROFILE + `/api/extractResumeDetails/${id}`, data)
    return Resume
}

export async function updateProfiles(data: any){
    const Resume = putAPI( REACT_APP_CANDIDATE + '/provider-resources', data)
    return Resume
}

export async function extractResume(data: any){
    const Resume = postAPI( REACT_APP_PROFILE + '/resume-details-ext', data)
    return Resume
}

export async function submitProfile(data: any){
    const Resume = putAPI( REACT_APP_CANDIDATE_FREELANCER+ `/candidate-status`, data)
    return Resume
}

export async function getProviderResources(){
    const Details = getAPI( REACT_APP_CUSTOMER + '/provider-resources')
    return Details
}

export async function getRecruiterResources(){
    const Details = getAPI( REACT_APP_RECRUITER + '/list')
    return Details
}

export async function getPositionDetails(candidateId: any) {
    const Details = getAPI(REACT_APP_JOB + `/position-details?candidateId=${candidateId}`)
    return Details
}

export async function sendCredentails(body: any) {
    const Details = postAPI( REACT_APP_CANDIDATE_FREELANCER+ '/credentials-email', body)
    return Details
}

export async function applyCandidateToJob(body: any) {
    const Details = postAPI( REACT_APP_JOB + '/candidate-job-application', body)
    return Details
}
